module.exports = __webpack_public_path__ + "img/details-bg@2x.9aed14db.png";